import templateOnly from '@ember/component/template-only';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div class=\'loading\'>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>");

var bbSpinner = setComponentTemplate(TEMPLATE, templateOnly());

export { bbSpinner as default };
//# sourceMappingURL=bb-spinner.js.map
